export const STANDARD_NUM_SYS_OPTION = {
    style: 'decimal',
    numberingSystem: 'latn',
    maximumFractionDigits: 20,
};
export const PLUGIN_NAME = 'CN_UTILS_I18N';
export const STANDARD_DATE_FORMAT = {
    s: 'YYYY-MM-DD HH:mm:ss',
    m: 'YYYY-MM-DD HH:mm',
    H: 'YYYY-MM-DD HH',
    D: 'YYYY-MM-DD',
    M: 'YYYY-MM',
    W: 'YYYY-[W]ww',
    Q: 'YYYY-[Q]Q',
    Y: 'YYYY',
    HH: 'HH',
    Hm: 'HH:mm',
    Hms: 'HH:mm:ss',
};
